"use strict";

exports.__esModule = true;
exports.BlockUI = void 0;

var _base = _interopRequireDefault(require("../../../styles/resets/base.css"));

var _index = _interopRequireDefault(require("../../styled/index"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BlockUI =
/*#__PURE__*/
(0, _index.default)('div', {
  target: "e1by4ru40"
})(_base.default, " flex:1;max-width:100%;min-width:0;");
exports.BlockUI = BlockUI;